import { withApolloTypename } from 'ZalamoLibrary/src/lib/core/graphql/with-apollo-typename';
import { Injectable } from '@angular/core';
import {
  GetTriplexLookBookConfigForPublicSessionGQL,
  GetTriplexLookBookConfigForPublicSessionQuery,
} from '../../../../../../../public-session/src/graphql';
import {
  GetLookBookTriplexDetailsForPrivateSessionGQL,
  GetLookBookTriplexDetailsForPrivateSessionQuery,
} from '../../../../../../../photographer-client/src/app/modules/private-sessions/graphql';
import { map } from 'rxjs';
import { Product } from '@ui/products/product-editor/graphql';

const addProductMap = <T extends { labProducts }>(ob: T) => {
  const productsMap: Record<
    string,
    Array<Product & { labId: string }>
  > = ob.labProducts.reduce(
    (prev, p) => {
      if (typeof prev[p.organizationId] === 'undefined') {
        prev[p.organizationId] = [];
      }
      prev[p.organizationId].push(
        withApolloTypename('Product', {
          ...p,
          tags: [],
          labId: p.organizationId,
        }),
      );
      return prev;
    },
    {} as {
      [x: string]: Array<Product & { labId: string }>;
    },
  );
  return { ...ob, productsMap };
};

@Injectable({
  providedIn: 'root',
})
export class TriplexFrontService {
  constructor(
    private getTriplexLookBookConfigForPublicSessionGQL: GetTriplexLookBookConfigForPublicSessionGQL,
    private triplexDetailsForPrivateSessionGQL: GetLookBookTriplexDetailsForPrivateSessionGQL,
  ) {}

  getDetails(context: 'PublicSession' | 'PrivateSession', contextId) {
    switch (context) {
      case 'PublicSession':
        return this.getTriplexLookBookConfigForPublicSessionGQL
          .fetch({
            variables: {
              publicSessionId: contextId,
            },
          })
          .pipe(
            map(({ data }) =>
              addProductMap<
                GetTriplexLookBookConfigForPublicSessionQuery['getTriplexLookBookConfigForPublicSession']
              >(data.getTriplexLookBookConfigForPublicSession),
            ),
            // shareReplay(1)
          );
      case 'PrivateSession':
        return this.triplexDetailsForPrivateSessionGQL
          .fetch({
            variables: {
              privateSessionId: contextId,
            },
          })
          .pipe(
            map(({ data }) =>
              addProductMap<
                GetLookBookTriplexDetailsForPrivateSessionQuery['getTriplexLookBookConfigForPrivateSession']
              >(data.getTriplexLookBookConfigForPrivateSession),
            ),
            // shareReplay(1)
          );
    }
  }
}
